export default [
  {
    "date": "20211116",
    "date_error": true,
    "date_result": "缺失该日期，请检查该目录",
    "error": [],
    "time_hours": []
  },
  {
    "date": "20211115",
    "date_error": true,
    "date_result": "缺失该日期，请检查该目录",
    "error": [],
    "time_hours": []
  },
  {
    "date": "20211114",
    "date_error": true,
    "date_result": "缺失该日期，请检查该目录",
    "error": [],
    "time_hours": []
  },
  {
    "date": "20211113",
    "date_error": true,
    "date_result": "缺失该日期，请检查该目录",
    "error": [],
    "time_hours": []
  },
  {
    "date": "20211112",
    "date_error": true,
    "date_result": "缺失该日期，请检查该目录",
    "error": [],
    "time_hours": []
  },
  {
    "date": "20211111",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "11",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "17",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211110",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "11",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211109",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "11",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "14",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "15",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "17",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211108",
    "date_error": true,
    "date_result": "缺失该日期，请检查该目录",
    "error": [],
    "time_hours": []
  },
  {
    "date": "20211105",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "11",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "15",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "17",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211028",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "14",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "15",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "17",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211027",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "11",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "14",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "15",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211014",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "11",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "15",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "17",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211013",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "00",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "01",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "03",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "04",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "14",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "15",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "17",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "19",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "21",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "23",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  },
  {
    "date": "20211009",
    "date_error": false,
    "date_result": "",
    "error": [
      {
        "hours": "02",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "05",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "06",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "07",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "08",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "09",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "10",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "12",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "13",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "14",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "16",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "18",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "20",
        "msg": "缺失该时间点的文件夹"
      },
      {
        "hours": "22",
        "msg": "缺失该时间点的文件夹"
      }
    ],
    "time_hours": [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23"
    ]
  }
]